var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-editor',{attrs:{"editorToolbar":_vm.attribute.editorToolbar},on:{"input":function($event){return _vm.$emit('input', $event)}},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }